import axios, { AxiosResponse, AxiosError } from 'axios';



export const axiosInstance = axios.create(
    {
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
    responseType: 'json',
    headers: { 
        'Content-Type': 'application/json',
        'Subscription-Key' : process.env.REACT_APP_SUBSCRIPTION_KEY    
    },
});

const responseSuccessHandler = (response: AxiosResponse) => response;

const responseErrorHandler = (error: AxiosError) => {
    if (error.status === 401) {
        window.location.href = '/logout';
    }
    return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
    (response: any) => responseSuccessHandler(response),
    (error:any) => responseErrorHandler(error),
);


axiosInstance.interceptors.request.use((config:any) => config)